export default {"src":"/_next/static/media/eca.05468082.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};